// extracted by mini-css-extract-plugin
export default {"legend-container":"legend_legend-container__cvwWB"};